import { Link } from "react-router-dom";

import Logo from "../../../assets/images/Skydive_logo_beta.svg";

import ROUTES from "../../../constants/routes";

import "./Help.scss";

const InstallingSkydive = () => {
  return (
    <div className="help-page">
      <div className="help-page-header">
        <Link to={ROUTES.ANALYTICS_VIEW.replace("/:id", "")}>
          <img src={Logo} alt="Skydive" className="help-page-logo" />
        </Link>
      </div>
      <div className="help-page-content">
        <h1>Installing Skydive Tracking Code (Manually)</h1>
        <p>
          Your Skydive tracking code needs to be installed within your site
          in order to start collecting data. You'll find your unique
          tracking code on the Install Tracking Code page, provided right
          after account creation or from your Settings page at any time.
        </p>
        <ol>
          <li>
            <strong>Compatibility check.</strong> Verify your website
            platform accepts external JavaScript code before proceeding.
          </li>
          <li>
            <strong>Copy the code.</strong> Locate your unique tracking code
            on the Install Tracking Code page and copy it using the provided
            button or manual selection.
          </li>
          <li>
            <strong>Paste in the head tag.</strong> Insert the code within
            the <code>&lt;head&gt;</code> section of your website's HTML.
          </li>
          <li>
            <strong>Keep the tab open.</strong> Do not close out this tab as
            you will need to come back to it to verify your tracking code
            installation.
          </li>
          <li>
            <strong>Verify installation.</strong> Return to Skydive and
            click the green "VERIFY MY CODE IS INSTALLED" button. The system
            automatically tests the connection.
          </li>
          <li>
            <strong>Confirmation.</strong> Upon successful verification,
            confirm the success pop-up to access your dashboard.
          </li>
        </ol>
        <p className="help-page-warning">
          <strong>Important:</strong> during verification, avoid closing
          tabs or navigating away, as this automated process requires
          stability to complete properly.
        </p>
      </div>
    </div>
  );
};

export default InstallingSkydive;
